import React, { FC } from 'react';

import { EvTextInput } from '@evinced-private/ui-common';

import { LOGIN_LABELS } from './LoginSettingsV2.labels';
import { CookiesLoginFieldsProps } from './LoginSettingsV2.types';

export const CookiesLoginFields: FC<CookiesLoginFieldsProps> = ({
	cookies,
	cookiesError,
	onCookiesChange
}) => (
	<div className="login-cookies">
		<div className="login-cookies-row">
			<span className="form-label">{LOGIN_LABELS.COOKIES_LABEL}</span>
			<div className="form-field">
				<EvTextInput
					ariaLabel={LOGIN_LABELS.COOKIES_ARIA_LABEL}
					isRequired
					value={cookies}
					placeholder={LOGIN_LABELS.COOKIES_PLACEHOLDER}
					error={cookiesError}
					onChange={onCookiesChange}
				/>
			</div>
		</div>
	</div>
);
